import {Constructor} from "../types/constructor";
import {Subject} from "rxjs";
import {OnDestroy} from "@angular/core";

export interface ObservableOnDestroy extends OnDestroy {
    destroy$: Subject<void>;
}

export function ObservableOnDestroyMixin<TBaseClass extends Constructor<any>>(
    BaseClass: TBaseClass
): TBaseClass & Constructor<ObservableOnDestroy> {
    return class ObservableOnDestroyExtension extends BaseClass implements ObservableOnDestroy {
        public destroy$: Subject<void> = new Subject<void>();

        public ngOnDestroy(): void {
            this.destroy$.next();
            this.destroy$.complete();
        }

    };
}
